declare namespace $ {

	type $mol_button_minor__title_shm_projects_digest_view_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_digest_view_2 = $mol_type_enforce<
		ReturnType< $shm_projects_digest_view['refresh'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_projects_release_notes_view__notes_shm_projects_digest_view_3 = $mol_type_enforce<
		ReturnType< $shm_projects_digest_view['notes'] >
		,
		ReturnType< $shm_projects_release_notes_view['notes'] >
	>
	type $shm_projects_release_notes_view__scope_text_shm_projects_digest_view_4 = $mol_type_enforce<
		ReturnType< $shm_projects_digest_view['updated_text'] >
		,
		ReturnType< $shm_projects_release_notes_view['scope_text'] >
	>
	type $shm_projects_release_notes_view__content_text_shm_projects_digest_view_5 = $mol_type_enforce<
		ReturnType< $shm_projects_digest_view['content_text'] >
		,
		ReturnType< $shm_projects_release_notes_view['content_text'] >
	>
	export class $shm_projects_digest_view extends $mol_section {
		refresh( next?: any ): any
		Refresh( ): $mol_button_minor
		notes( ): any
		updated_text( ): string
		content_text( ): string
		Notes( ): $shm_projects_release_notes_view
		title( ): string
		digest( ): any
		tools( ): readonly(any)[]
		content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=view.view.tree.d.ts.map